export const ADD_MERCHANT = gql`
    mutation AddMerchantApplication($input: AddMerchantApplicationInput) {
        addMerchantApplication(input: $input) {
            id
            serviceRequirements
            merchantInformation
            outletInformation
            businessInformation
            supportingDocuments
            partnerId
            partnerType
            partnerOfPartnerId
            isServiceApplication
            status
            partner {
                countryDetails {
                    alpha2Code
                    currencies {
                        symbol
                    }
                }
            }
            trialPeriod
            country
        }
    }
`;

export const UPDATE_MERCHANT_PRINCIPALS = gql`
    mutation UpdateMerchantPrincipals($input: UpdateMerchantPrincipalsInput) {
        updateMerchantPrincipals(input: $input) {
            fullName
        }
    }
`;
